export enum MessageStatus {
    Sent = 0,
    Draft = 1,
    Rejected = 2
}
